import { createFileRoute } from '@tanstack/react-router'
import SubmissionIndex from '@/pages/partners/components/submission'

export const Route = createFileRoute(
  '/_authenticated/partners/$partnerId/submission/$submissionId'
)({
  component: SubmissionIndex,
})
